"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _color = require("../../../scripts/utils/color");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = function _default(_ref) {
  var colorScheme = _ref.colorScheme;
  var color0 = colorScheme.color0,
      color1 = colorScheme.color1,
      color2 = colorScheme.color2,
      color3 = colorScheme.color3,
      color4 = colorScheme.color4,
      color5 = colorScheme.color5;
  var DEFAULT_SECTION_ATOMS = {
    _section: {
      sectionMain: {
        backgroundColor: color4
      },
      sectionSecondary: {
        backgroundColor: color5
      }
    }
  };
  var DEFAULT_ELEMENT_HEADER = {
    header: {
      main: {
        color: color1
      }
    }
  };
  return {
    header: {
      _section: {
        sectionSecondary: {
          backgroundColor: null
        },
        sectionMain: {
          backgroundColor: (0, _color.setAlpha)(color5, 0.85)
        }
      },
      eventName: {
        main: {
          color: color2
        }
      },
      registerButton: {
        main: {
          color: color5,
          backgroundColor: color0,
          borderColor: (0, _color.setAlpha)('#000000', 0.2)
        }
      },
      eventDate: {
        main: {
          color: color2
        }
      },
      eventVenue: {
        main: {
          color: color2
        }
      },
      eventSecondaryHeaders: {
        header1: {
          color: color2
        },
        header2: {
          color: color2
        }
      }
    },
    description: _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_SECTION_ATOMS), DEFAULT_ELEMENT_HEADER), {}, {
      description: {
        main: {
          color: color3
        }
      }
    }),
    tickets: _objectSpread(_objectSpread({}, DEFAULT_SECTION_ATOMS), DEFAULT_ELEMENT_HEADER),
    speakers: _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_SECTION_ATOMS), DEFAULT_ELEMENT_HEADER), {}, {
      speakers: {
        fullname: {
          color: color2
        },
        text1: {
          color: color1
        },
        text2: {
          color: color1
        }
      }
    }),
    attendees: _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_SECTION_ATOMS), DEFAULT_ELEMENT_HEADER), {}, {
      attendees: {
        fullname: {
          color: color2
        },
        text1: {
          color: color3
        }
      },
      button: {
        main: {
          color: '#FFFFFF',
          backgroundColor: color1
        }
      }
    }),
    people: {
      _section: {
        sectionMain: {
          backgroundColor: color4
        },
        sectionSecondary: {
          backgroundColor: color5
        }
      },
      header: {
        main: {
          color: color3
        }
      },
      people: {
        text1: {
          color: color2
        },
        text2: {
          color: color3
        },
        text3: {
          color: color3
        }
      }
    },
    sponsors: _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_SECTION_ATOMS), DEFAULT_ELEMENT_HEADER), {}, {
      sponsors: {
        main: {
          color: '#595a5c'
        }
      }
    }),
    exhibitors: _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_SECTION_ATOMS), DEFAULT_ELEMENT_HEADER), {}, {
      exhibitors: {
        main: {
          color: '#595a5c'
        }
      }
    }),
    multiElement: {
      _section: {
        sectionMain: {
          backgroundColor: color4
        },
        sectionSecondary: {
          backgroundColor: color5
        }
      },
      header: {
        main: {
          color: color3
        }
      }
    },
    form: _objectSpread(_objectSpread({}, DEFAULT_SECTION_ATOMS), {}, {
      form: {
        title: {
          color: color1
        },
        separator: {
          color: color3
        },
        label: {
          color: color3
        },
        button: {
          backgroundColor: color1,
          color: '#FFFFFF'
        },
        secondaryLabel: {
          color: color3
        }
      }
    }),
    buttons: {
      _section: {
        sectionMain: {
          backgroundColor: color4
        },
        sectionSecondary: {
          backgroundColor: color5
        }
      },
      eventButtons: {
        main: {
          backgroundColor: '#ffffff',
          color: '#2BB0E9',
          borderColor: '#2BB0E9'
        }
      }
    },
    downloadApp: {
      _section: {
        sectionMain: {
          backgroundColor: color4
        },
        sectionSecondary: {
          backgroundColor: color5
        },
        text: {
          color: color2
        },
        highlight: {
          color: color2
        }
      }
    },
    iframe: _objectSpread({}, DEFAULT_SECTION_ATOMS),
    countdownClock: _objectSpread(_objectSpread(_objectSpread({}, DEFAULT_SECTION_ATOMS), DEFAULT_ELEMENT_HEADER), {}, {
      countdownClock: {
        main: {
          color: color1
        },
        text: {
          color: color3
        }
      }
    }),
    eventVenue: _objectSpread(_objectSpread({
      _section: {
        sectionSecondary: {
          backgroundColor: color5
        }
      }
    }, DEFAULT_ELEMENT_HEADER), {}, {
      eventVenue: {
        main: {
          color: color1
        },
        text: {
          color: color3
        }
      }
    })
  };
};

exports.default = _default;